import React, { useRef } from "react";
import { ArrowLetAlt, Next, Prev } from "assets";
import FreelanceCard, { FreelanceCardLoading } from "components/cards/FreelanceCard";
import Header from "components/headerfull";
import { useEffect, useState } from "react";
import { __search, _getFilters, _getFreelances } from "services/parcours/freelance.service";
import { CallToAction } from "./about-us";

import Reviews from '../assets/reviews.svg';
import ArrowDropDown from '../assets/arrow_drop_down.svg';
import Reset from '../assets/reset.svg';
import ArrRight from '../assets/arrow_drop_right.svg';
import Close from '../assets/close-small.svg';

import UNIS from '../assets/UNIS.json';
import UniversitiesSlider from "components/universitySlider/UniversitiesSlider";
import { FooterMaximized } from "components/footerfull";
import { AnyARecord } from "dns";
import Select from "components/ui/Forms/Select";
import Form from "components/ui/Forms";
import Input from "components/ui/Forms/Input";
import { FormikProvider, useFormik } from "formik";
import { makeAlotOfEmptyStars, makeAlotOfStars } from "components/company-slides";
import { useNavigate, useSearchParams } from "react-router-dom";
import { generateQueryString } from "utils";
import useCleanQueryParams from "hooks/useCleanQueryParams";

import "../styles/additional.css";

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if (el !== null) {
        el.setAttribute('content', desc);
    }
}

const Pagination = ({ total_pages, currentPage, onHandlePage }: any) => {
    const [eachPages , setEachPages]: [number[], any] = useState<number[]>([])
    const [numberOfPages, setNumberOfPages] = useState(2)
    const [start, setStart] = useState(0)
    const [eachFilteredPages , setEachFilteredPages]: [number[], any] = useState<number[]>([])
    const handlePrev = () => {
        onHandlePage((prev: any) => {
            const i = prev.page > 1 ? --prev.page : 1
            if(!eachFilteredPages.includes(i)){
                // setEachFilteredPages(eachPages.slice(start,numberOfPages))
                setStart(prev=>--prev)
                setNumberOfPages(prev=>--prev)
            }
            return {
                ...prev,
                page: i
            };
        });
    };

    const handleNext = () => {
        onHandlePage((prev: any) => {
            const i =  prev.page < total_pages ? ++prev.page : total_pages
            if(!eachFilteredPages.includes(i)){
                // setEachFilteredPages(eachPages.slice(start,numberOfPages))
                setStart(prev=>++prev)
                setNumberOfPages(prev=>++prev)
            }
            return {
                ...prev,
                page: i
            };
        });
    };

    useEffect(()=>{ 
        setEachPages(Array.from({length: total_pages}, (_, i)=> i + 1))
    },[total_pages])

    useEffect(()=>{
        setEachFilteredPages(eachPages.slice(start,numberOfPages))
    },[eachPages, start, numberOfPages])


    if (total_pages === 1 || total_pages === 0) return null;
    return (
        <div className="flex justify-center my-4 w-full">
            <div className="flex items-center space-x-4">
                <button onClick={handlePrev}>
                    <img src={Prev} />
                </button>
                {/*
                    eachFilteredPages.map((el:any,i:any)=>{
                        return (
                            <div className={`text-[18px] text-[#6F6F6F] ${el === currentPage ? 'bg-gray-100 px-4 py-2 rounded-lg':''}`}>{el}</div>
                        )
                    })
                */}
                <div className={`text-[18px] text-[#6F6F6F]`}>{currentPage + ` / ${total_pages}`}</div>
                <button onClick={handleNext}>
                    <img src={Next} />
                </button>
            </div>
        </div>
    )
}

export default function Freelances() {
    const navigate = useNavigate()

    useEffect(() => {
        document.title = "Découvrez nos freelances - Experts disponibles";
        const desc = "Explorez notre vaste sélection de freelances qualifiés. Trouvez le profil idéal pour votre entreprise, vos projet et missions.";
        setDescription(desc);
    }, []);

    const [filters, setFilters]: any = useState([]);
    const [initialValues, setInitialValues] = useState({});
  

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit(values, formikHelpers) {
            console.log({ values });
            
        },
    });

    const { handleSubmit, values, handleChange, handleReset }: any = formik;

    return (
        <>
            <div className="w-full relative">
                <Header type="default" />

                <Banner />
                <div className="mt-[141px] w-full">
                    <PaginatedFreelancesDisplayer />
                </div>

                <div className="w-full relative mt-[140px] max-w-[100vw] overflow-clip" style={{ backgroundImage: `linear-gradient(0deg, #f4f4f5 0%, #f4f4f5 50%, white 50%, white 50%)` }}>
                    <CallToAction isFreelance={true} isAbsolute={false} />
                </div>

                <div className="w-full py-[115px] bg-[#f4f4f5]">
                    <UniversitiesSlider UNIS={UNIS} bigMargin={false} needMargin={false} />
                </div>

                <FooterMaximized />
            </div>
        </>
    );
};

const Banner = () => {
    return <>
        <div className="w-full md:h-[398px] h-[265px] relative bg-cover bg-center bg-norepeat flex items-center justify-center" style={{ backgroundImage: `url('/freelance-banner.webp')` }}>
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-primary-blue opacity-80 z-1"></div>
            <div className="flex flex-col gap-[8px] items-center justify-center lg:max-w-[943px] max-w-[90vw] mx-auto my-auto relative z-2">
                <img src="/svg/logo-transparent.svg" alt="WOS logo" width={250} height={41.13} className="md:w-[250px] md:h-[41.13px] w-[160px] h-[26.32px]" />
                <h1 className="text-white lg:text-[60px] lg:leading-[72px] text-[30px] leading-[36px] font-semibold">Besoin d'un freelance ?</h1>
                <p className="lg:text-[20px] text-[#f4f4f5] lg:leading-[24px] text-[16px] leading-[19.2px] font-normal font-dm-sans text-center">Trouvez des freelances qualifiés, sélectionnés pour leur expertise, à des tarifs compétitifs. Bénéficiez d'une collaboration simple et efficace, partout dans le monde.</p>
            </div>
        </div>
    </>;
};

export const PaginatedFreelancesDisplayer = ({ onSetLiveAveragePriceData }: any) => {
    const [freelances, setFreelances] = useState([]);
    const [searchParams]:any = useSearchParams();
    const navigate = useNavigate()
    const [pageConf, setPageConf] = useState({
        page: 1,
        pageSize: 12,
        totalPage: 0
    });
    
    const [freelancesLoading, setFreelancesLoading]= useState<boolean>(true);

    useEffect(() => { 
        (async function () {
            const currentParams = new URLSearchParams(searchParams.toString());
            currentParams.set("page_size", String(pageConf.pageSize));
            currentParams.set("page", String(pageConf.page));
            navigate(`?${currentParams.toString()}`, { replace: true });
            // let freelances = await _getFreelances(`?page_size=${pageConf.pageSize}&page=${pageConf.page}`);
            // setFreelancesLoading(false);
            // // let filters = await _getFilters();

            // setFreelances(freelances.data);
            // console.log({ freelances });
            // setPageConf({ ...pageConf, totalPage: freelances.pagination.total_pages });
        })();
    }, [pageConf.page]);
    
    const [showFilters, setShowFilters]= useState(false);

    const [searchString, setSearchString]= useState<string>("");
    const handleSearching= (event: any) => {
        setSearchString(event.currentTarget.value);
    };
    const triggerSearch = (e:any)=>{
        e.preventDefault();

        const currentParams = new URLSearchParams(searchParams.toString());

        if (!searchString) {
            currentParams.delete("search");
        } else {
            currentParams.set("search", searchString);
        }

        navigate(`?${currentParams.toString()}`, { replace: true });
    }

    const searchNow= async (keyword:string) => {
        // alert(searchString);
        setFreelancesLoading(true);


        try {
            const response:any = await  _getFreelances(`?${keyword}`)
            setPageConf({ ...pageConf, totalPage: response.pagination.total_pages });
            setFreelances(response.data)
            onSetLiveAveragePriceData(response?.average_price_review?.map((el:any)=>({
                "job": {
                    "jobTitle": el.name,
                    "outSalary": el.eu_average_price,
                    "inSalary": el.wos_average_price_daily,
                    "inMonthlySalary": el.wos_average_price_monthly
                }
            })))
           
            console.log({response})
        } catch (error) {
            console.log({error})
        }finally{
            setFreelancesLoading(false)
        }
    };



    useEffect(() => {
        if(searchParams.toString()){
            setSearchString(searchParams.get('search'))
            searchNow(`${searchParams.toString()}`)
        }
      }, [searchParams.toString()]);

    return <>
    <div className="w-full px-[40px] max-w-[100vw]">
        <div className="flex md:flex-row flex-col gap-[30px] w-max md:items-start items-center max-w-[1390px] mx-auto paginated-freel">
            <div className="flex p-[20px] justify-between w-full md:hidden block max-[758px]:max-w-[325px] rounded-[10px] border-[1px] border-[#6f6f6f]" onClick={()=>{setShowFilters(true)}} id="show-filters" >
                <div className="text-primary-blue font-semibold text-[25px] leading-[30px]">Filtres</div>
                <img src={ArrRight} alt="ARR_RIGHT" />
            </div>
            <FiltersSidebar showFilters={showFilters} setShowFilters={setShowFilters} />
            <div className="flex flex-col md:items-start items-center">
                <div className="w-full mb-[20px] relative maleable-container">
                    <form onSubmit={triggerSearch}>
                        <input type="text" className="border-[1px] border-[#bbbbc4] px-[50px] py-[20px] rounded-[50px] w-full md:text-[1em] text-[.92em]" placeholder="Recherchez des freelances" value={searchString} onChange={handleSearching}/>
                        <button className="absolute top-[50%] right-[10px] transform translate-y-[-50%] p-[0px] rounded-[50%]">
                            <img src={Next} alt="ARR" />
                        </button>
                    </form>
                </div>

                {/* <div className="grid grid-cols-3 md:gap-[20px] gap-[10px] md:ml-[30px]"> */}
                <div className="flex xl:max-w-[97%] flex-wrap md:justify-start justify-center mb-4 md:gap-[20px] gap-[10px] maleable-container">

                    {/* flex max-w-[97%] flex-wrap md:justify-end justify-center mb-4 md:gap-[20px] gap-[10px] */}
                    {
                        freelancesLoading ?
                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((el:any, index: number)=>(
                            <FreelanceCardLoading isWhite={false}/>
                        ))
                        :
                        freelances.map((el:any)=>{
                            return ( 
                                <FreelanceCard rating={el?.avg_rating} firstname={el?.name?.split(' ')[0]} lastname={el?.name?.split(' ')?.slice(1)?.join(' ')} photo={el.image_url.image_url_512 ?? el.image_url.image_url_128} audioAvailable={el.audio} salary={el.price_per_month} ratersNumber={el.rate_number} skills={el?.competences.map((el:any)=>el?.name)} online={true} xp={el?.experience} jobTitle={el?.favorite_domain && el.favorite_domain[0].name} id={el.id}/>
                            )
                        })
                    }
                </div>
                <Pagination total_pages={pageConf.totalPage} currentPage={pageConf.page} onHandlePage={setPageConf} />
            </div>
        </div>
    </div>
    </>;
};


const FiltersSidebar= ({showFilters, setShowFilters}: {showFilters: boolean, setShowFilters: any}) => {
    // const [filtersState, setFiltersState]= useState<any>({});
    const [filtersLoading, setFiltersLoading]= useState<boolean>(true);
    const [searchParams]= useSearchParams()
    const navigate= useNavigate()
    const cleanQueryParams = useCleanQueryParams();

    const [loading, setLoading]= useState(true);

    const [filters, setFilters]= useState<any>({});
    const [filtersFiltered, setFiltersFiltered]= useState<any>({});
    const [updatedField, setUpdatedField]= useState('')
    const [dependsOn, setDependsOn]= useState<any>({
        "Compétences":"Métier", //competences depends de metier
        "Outils":"Métier",
        "Métier":"Catégories"
    });
    const [dependsOnFilteringKey, ]= useState<any>({
        "Compétences":{
            key:"category_id",
        },
        "Outils":{
            key:"category_id",
        },
        "Métier":{
            key:"global_domain_id",
        }
    });
    
    const [initialValues, setInitialValues]:any= useState({
        options: [],//<- for the options that do not belong inside a group (ex: description audio, disponible immediatement)
    });
    // const [initialValues, setInitialValues]= useState({
    //     bare_options: [],
    //     jobCateg_0: [],
    //     domain: [],
    //     lang: [],
    //     skill: [],
    //     country: [],
    //     star: [],
    //     price: []
    // });

    // const skillsList= [
    //     {title: "Suivi du projet"},
    //     {title: "Gestion de projet"},
    //     {title: "NTIC"},
    //     {title: "Relation client"},
    //     {title: "Planning & Suivi"},
    //     {title: "Carte de visite"},
    //     {title: "Plaquettes"},
    //     {title: "Suite Adobe"},
    //     {title: "Wireframing"},
    //     {title: "Responsive Design"},
    //     {title: "UI/UX"}
    // ];
    // const langsList= [
    //     {title: "Français"},
    //     {title: "Anglais"},
    //     {title: "Espagnol"},
    // ];
    // const PricesList= [
    //     {title: "Moins de 200€"},
    //     {title: "200€ à 500€"},
    //     {title: "500€ à 750€"},
    //     {title: "750€ à 1000€"},
    //     {title: "1000€ et plus"},
    // ];
    // const CountryList= [
    //     {title: "Afrique du Sud"},
    //     {title: "Albanie"},
    //     {title: "Algérie"},
    //     {title: "Allemagne"},
    // ];

    const formik: any = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit(values, formikHelpers) {
            console.log({ values });
            
            const queryString: any = generateQueryString(values);
            const newParams = new URLSearchParams(queryString);
            const currentParams = new URLSearchParams(searchParams.toString());

            console.log({queryString})

            // Merge query parameters while ensuring uniqueness
            newParams.forEach((value, key) => {
                if (currentParams.has(key)) {
                    currentParams.delete(key); // Remove the old key-value pair
                  }
                currentParams.set(key, value); // This ensures only the latest value remains
            });

            currentParams.forEach((value, key) => {
                // Decode the parameter value
                const decodedValue = decodeURIComponent(value);
                console.log({decodedValue})
                // Replace the encoded value with the decoded one
                currentParams.set(key, decodedValue);
              });
              
            

            console.log(decodeURIComponent(currentParams.toString()))

            navigate(`?${decodeURIComponent(currentParams.toString())}`, { replace: true });
        },
    });

    

    const handleClick= (event: any) => {
        const {name, value}= event.currentTarget;
        console.log(event.currentTarget);
        console.log(event.currentTarget.checked);
        console.log(name);
        console.log(value);
        console.log(formik.values[name]);
        console.log(formik.values);
        if(formik.values[name]!== value){
            //
        } else {
            formik.setFieldValue(name, '');
        }
    };

    const handleRadio= (event: any) => {
        const {name, value}= event.currentTarget;
        formik.handleChange(event);
    };

    
    const [showFiltersButtonPosition, setShowFiltersWhatever]= useState<number>(0);
    
    // useEffect(()=>{
    //     console.log(showFiltersButtonPosition);
    //     console.log(window.scrollY);
    // }, [showFiltersButtonPosition]);
    useEffect(() => {
        //getting the position of the show filters button :
        const updateShowFiltersWhateverOnScroll=() => {
            setShowFiltersWhatever(document.getElementById("show-filters")?.getBoundingClientRect().top||150);
        };
        updateShowFiltersWhateverOnScroll();

        window.addEventListener("scroll", updateShowFiltersWhateverOnScroll);


        (async function () {
            let filters = await _getFilters();
            
            // setFilters(Object.entries(filters).map(([key, value]: any) => ({ label: key, value: value })));
            setFilters(filters);
            setFiltersLoading(false);
            setInitialValues((prev:any) => {//<-populate the filters with values from the API
                let t = Object.keys(filters), r: any = {};
                t.forEach(el => r[el] = filters[el]?.data?.length? []: false);
                return {...r, ...prev};
            });
        })();

        return(()=> {
            window.removeEventListener("scroll", updateShowFiltersWhateverOnScroll);
        });
    }, []);

    useEffect(()=>{
        if(JSON.stringify(filters)!==JSON.stringify({})){
            setLoading(false);
            setFiltersFiltered(filters)
        }
    }, [filters]);


    useEffect(()=> {

        if (updatedField) {
            // Trouver le champ qui depends de lui
            let dep = Object.keys(dependsOn).filter(key => dependsOn[key] === updatedField);

            console.log({dep})
        
            if (dep.length) {

                let updatedFilters = JSON.parse(JSON.stringify(filtersFiltered)); 

                let originalFilters = JSON.parse(JSON.stringify(filters)); 

                for(let i=0; i<dep.length;i++){
                    updatedFilters[dep[i]].data = originalFilters[dep[i]]?.data?.filter((el:any) =>
    
                        formik.values[updatedField]?.some((j: any) => typeof el[dependsOnFilteringKey[dep[i]]?.key] !== 'boolean' && el[dependsOnFilteringKey[dep[i]]?.key]?.includes(j.toString()))
    
                    );

                    if(!updatedFilters[dep[i]]?.data?.length) updatedFilters[dep[i]].data=originalFilters[dep[i]].data // in case there is no valuebring the original value
                }


                console.log({updatedFilters})
        

        
                setFiltersFiltered(updatedFilters);
            }
        }

    }, [formik.values[updatedField]]);

    const resetFilters= (event: any) => {
        event.preventDefault();
        formik.resetForm()
        cleanQueryParams(['search', 'page', 'page_size'])
    };

    const handleChange = (e:any)=>{
        setUpdatedField(e.target.name)
        formik.handleChange(e)
    }


    //Imma change the classname programatically so that in mobile version (<= 758px the filters bar shows up only when showFilters is set to true)

    return<>
        <div className={showFilters ? "wrapper md:w-[290px] min-w-[290px] w-full md:bg-white bg-[#1D1D39ee] md:flex flex-col gap-[28px] md:justify-center justify-start items-center overflow-y-auto md:static absolute top-0 left-0 right-0 bottom-0 gap-0 md:z-[2] z-[8] flex" : "wrapper md:w-[290px] min-w-[290px] w-full md:bg-white bg-[#1D1D39ee] md:flex flex-col gap-[28px] justify-center items-center overflow-y-auto md:static absolute top-0 left-0 right-0 bottom-0 gap-0 md:z-[2] z-[8] hidden "} onClick={(e)=>{if(e.target===e.currentTarget){setShowFilters(false)}}}>
        {/* <div className="wrapper md:w-[290px] min-w-[290px] w-full md:bg-white bg-[#1D1D39ee] md:flex hidden flex-col gap-[28px] justify-center items-center overflow-y-auto md:static fixed top-0 left-0 right-0 bottom-0 gap-0 z-2"> */}
                <div className={"flex justify-between w-full max-w-[290px] gap-[10px] "} style={{marginTop: showFilters ? showFiltersButtonPosition + window.scrollY + 20 : "0" }}>
                    <div className="md:text-primary-blue text-white font-semibold text-[25px] leading-[30px] mr-auto">Filtres</div>
                    <div className="bg-[#f4f4f5] hover:bg-[#e0e0e1] duration-300 cursor-pointer flex items-center justify-center rounded-[10px] w-[30px] h-[30px] ml-auto" onClick={resetFilters} title="Réinitialiser les filtres"><img src={Reset} alt="RESET" /></div>
                    <div className="bg-[#f4f4f5] hover:bg-[#e0e0e1] duration-300 cursor-pointer md:hidden flex items-center justify-center rounded-[10px] w-[30px] h-[30px]" onClick={()=> {setShowFilters(false)}} title="Fermer"><img src={Close} alt="CLOSE" className="w-[10px]"/></div>
                </div>
                <form onSubmit={formik.handleSubmit}>
                    <div className="w-[290px] bg-white flex flex-col rounded-[10px] border-[#bbbbc4] border-[1px] filters-column">
                        {/* <FilterCheckbox handleChange={formik.handleChange} labelText="Disponible immédiatement" name="options" id="bookable" checked={formik.values["options"].includes('bookable')} />
                        <FilterCheckbox handleChange={formik.handleChange} labelText="Présentation audio" name="options" id="audio" checked={formik.values["options"].includes('audio')} /> */}
                        
                        {
                            filtersLoading ?
                            [1, 2, 3, 4, 5, 6, 7, 8].map((el: any, index: number)=>(
                                <LoadingFilter />
                            ))
                            :
                            !loading
                            &&
                            Object.keys(filtersFiltered).map((element: any, index: number)=>(
                                (
                                    filtersFiltered[element]?.data?.length ?
                                    element === "Commentaires clients"?
                                    (
                                        <DropDownFiltersStarsGroup
                                            // handleChange={formik.handleChange}
                                            handleChange={handleRadio}
                                            icon={Reviews}
                                            title={element}
                                            prefix={element}
                                            list={filtersFiltered[element]?.data}
                                            values={formik.values}
                                            handleClick={handleClick}
                                        />
                                    )
                                    :<DropDownFiltersGroup
                                        handleChange={handleChange}
                                        icon={filtersFiltered[element]?.icon}
                                        title={element}
                                        checkboxList={filtersFiltered[element]?.data}
                                        prefix={element}
                                        values={formik.values}
                                    />
                                    :<FilterCheckbox handleChange={handleChange} labelText={element} name={element} id={element.split(' ')[0]} checked={formik.values[element]} />
                                )
                            ))
                        }
                        <button type="submit" className="bg-primary-blue hover:bg-[rgba(59,59,91)] text-white px-4 py-2 rounded-[4px] m-[12px]">Appliquer</button>
                    </div>
                </form>
        </div>
    </>;
};

const DropDownFiltersGroup= ({handleChange, icon, title, checkboxList, prefix, values}: {handleChange: (event: any)=>void, icon: any, title: string, checkboxList: any, prefix: string, values: any}) => {

    // console.log(checkboxList);

    const [open, setOpen]= useState(false);
    const [data, setData] = useState([])


    useEffect(()=>{
        // console.log({checkboxList})
        setData(checkboxList)
    },[checkboxList])

    const handleFilter = (value:string)=>{
        console.log({value})
        if(value){
            setData(checkboxList.filter((e:any)=>e.name.toLowerCase().includes(value.toLowerCase())))
            console.log(checkboxList.filter((e:any)=>e.name.toLowerCase().includes(value.toLowerCase())))
        }
        else
            setData(checkboxList)
    }   

    const arrowClass= open? "ml-auto transform scale-y-[-1] w-[10px]" : "ml-auto w-[10px]";

    const mainClass= !open ? "px-[25px] py-[20px] flex flex-row gap-[10px] font-semibold text-[16px] leading-[19.2px] text-primary-blue cursor-pointer transition-all duration-500" : "px-[25px] py-[20px] flex flex-row gap-[10px] font-semibold text-[16px] leading-[19.2px] text-primary-blue cursor-pointer transition-all duration-500 pb-[10px]";

    const contentRef= useRef<HTMLDivElement>(null);
    return<div className="w-full flex flex-col" key={Math.random()}>
            <div className={mainClass} onClick={()=>{setOpen(o=>!o)}}>
                <img src={icon} alt="Folder" className="w-[16px]"/>
                <span className="text-[16px]">{title}</span>
                <img src={ArrowDropDown} alt="Arrow" className={arrowClass}/>
            </div>
            <div className="w-full transition-all duration-300 overflow-x-hidden overflow-y-auto " style={{height: open ? checkboxList?.length>10? "25rem":"auto": "0"}}> {/* contentRef.current?.scrollHeight a voir  */}
                <div className="flex justify-center mx-4 my-2" >
                    {['Pays', 'Langues'].includes(title) && <input type="search" placeholder="Rechercher..." className="!bg-[#F4F4F5] rounded-md placeholder:pl-2 placeholder:text-md placeholder:font-light placeholder:font-bricolage-grotesque outline-none block w-full" onChange={(e:any)=>handleFilter(e.target.value)}/>}
                </div>
                <div className="w-full flex flex-col ml-[.5rem]" ref={contentRef}>
                    {
                        data.map((el: any, index: number)=>(
                            <FilterCheckbox handleChange={handleChange} labelText={el.name} id={el.name} name={prefix} key={prefix + index} padding="10" color="[#6f6f6f]" font="normal" checked={values[prefix].includes(el.name)}/>
                        ))
                    }
                </div>
            </div>
        </div>;
};

const DropDownFiltersStarsGroup= ({handleChange, handleClick, icon, title, prefix, values,list}: {handleChange: (event: any)=>void, handleClick: (event: any)=>void, icon: any, title: string, list:any, prefix: string, values: any}) => {

    const [open, setOpen]= useState(false);
    const arrowClass= open? "ml-auto transform scale-y-[-1] w-[10px]" : "ml-auto w-[10px]";

    const mainClass= !open ? "px-[25px] py-[20px] flex flex-row gap-[10px] font-semibold text-[16px] leading-[19.2px] text-primary-blue cursor-pointer transition-all duration-500" : "px-[25px] py-[20px] flex flex-row gap-[10px] font-semibold text-[16px] leading-[19.2px] text-primary-blue cursor-pointer transition-all duration-500 pb-[10px]";

    const contentRef= useRef<HTMLDivElement>(null);
    return<div className="w-full flex flex-col" key={Math.random()}>
            <div className={mainClass} onClick={()=>{setOpen(o=>!o)}}>
                <img src={icon} alt="Folder" className="w-[16px]"/>
                <span className="text-[16px]" >{title}</span>
                <img src={ArrowDropDown} alt="Arrow" className={arrowClass}/>
            </div>
            <div className="w-full transition-all duration-300 overflow-hidden" style={{height: open ? contentRef.current?.scrollHeight : "0"}}>
                <div className="w-full flex flex-col-reverse gap-[5px] ml-[.5rem] pb-[30px]" ref={contentRef}>
                    {
                        list.map((element: any, index: number)=>(
                            <div key={prefix + index} className="ml-[25px] w-[171px] py-[3px] rounded-[5px] flex flex-row justify-center text-[14px] leading-[16.8px] font-normal text-[#6f6f6f] stars-radio">
                                {/* <input type="checkbox" onChange={handleChange} name={prefix} id={element.rating} checked={values[prefix].includes(element.rating.toString())} value={element.rating}/> */}
                                <input type="radio" onClick={handleClick} onChange={handleChange} name={prefix} id={element.rating} checked={values[prefix] === element.rating.toString()} value={element.rating} />
                                <label htmlFor={element.rating} className="flex flex-row gap-[5px] filters-rating">
                                    {makeAlotOfStars(index + 1)}
                                    {makeAlotOfEmptyStars(5 - index - 1)}
                                    et plus
                                </label>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>;
};

export const FilterCheckbox= ({handleChange, labelText, id, name, padding= "20", color="primary-blue", font="semibold", checked}: {handleChange: (event: any)=>void, labelText: string, id: any, name: string, padding?: string, color?: string, font?: string, checked: boolean}) => {
    return<div className={`px-[25px] py-[${padding}px] flex flex-row gap-[10px] font-${font} text-[16px] leading-[19.2px] text-${color} relative`} key={Math.random()}>
            {/* <input type="checkbox" name={name} id={id} value={id} onChange={handleChange} checked={checked} className="self-start relative top-[3px] cursor-pointer"/> */}
            <input type="checkbox" name={name} id={id} value={id} onChange={handleChange} checked={checked} className="wos-shaded-checkbox self-start relative top-[3px] cursor-pointer peer shrink-0 appearance-none w-[12px] h-[12px] border-2 border-[#6f6f6f] rounded-sm !bg-white hover:not-checked:!bg-[#1d1d3933] checked:bg-blue-800 checked:border-0 before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primary-blue checked:!bg-primary-blue checked:before:bg-primary-blue hover:before:opacity-10"/>
            <svg
                className="absolute w-4 h-4 mt-1 hidden peer-checked:block pointer-events-none max-w-[10px] transform translate-x-[1px] translate-y-[-2px]"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <label htmlFor={id} className="cursor-pointer">{labelText}</label>
        </div>;
};

const LoadingFilter= () => {
    return<div className="px-[25px] py-[20px] w-full flex flex-col items-center justify-center" key={Math.random()}>
            <div className="w-full !h-[20px] loading-card-image"></div>
        </div>;
};